import { Chip } from "@mui/material";
import Stack from "atoms/Stack";
import { COLOR_BLACK, COLOR_GREY_BORDER } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING, SPACING_DENSE } from "helpers/spacings";
import React from "react";

export default function Section({ icon, title, labels, children, component: Component = "div", ...others }) {
  return (
    <Component
      data-test-section
      {...others}
      style={{
        //
        ...others.style,
        display: "flex",
        flexFlow: "column nowrap",
        gap: SPACING,
      }}
    >
      <div
        style={{
          color: "inherit",
          paddingTop: SPACING,
          paddingBottom: SPACING_DENSE,
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center",
          gap: SPACING_DENSE,
          borderBottom: `1px solid ${COLOR_GREY_BORDER}`,
        }}
      >
        {icon &&
          React.cloneElement(icon, {
            fontSize: "inherit",
            style: { fontSize: 16 },
          })}
        <div
          style={{
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontWeight: 500,
            letterSpacing: 0.4,
            color: COLOR_BLACK,
            fontSize: 16,
          }}
        >
          {title}
        </div>
        {labels}
      </div>
      <Stack>{children}</Stack>
    </Component>
  );
}

export function SectionLabel({ label, selected, onClick }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      style={{ fontFamily: FONT_FAMILY_GRAPHIK, fontWeight: 400, fontSize: 11 }}
      color={selected ? "secondary" : "default"}
      onClick={onClick}
      label={label}
    />
  );
}
